/*
 * Panneau d'affichage du code personnel (6 chiffres, genere localement).
 * Reutilise aux etapes code, confirmation et echec du dialog d'envoi.
 */

export const PersonalCodePanel = ({ code, testId, compact = false }) => (
  <div
    className={`rounded-2xl bg-[#235277] text-center ${compact ? "py-5" : "py-6"}`}
    data-testid={testId}
    aria-label={`Ton code personnel : ${String(code).split("").join(" ")}`}
  >
    <span
      className={`font-heading font-bold tracking-[0.35em] text-[#EAFE63] pl-[0.35em] tabular-nums ${
        compact ? "text-3xl" : "text-4xl"
      }`}
    >
      {code}
    </span>
  </div>
);
